/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyDurationInfo,
    JsonCompanyDurationInfoFromJSON,
    JsonCompanyDurationInfoFromJSONTyped,
    JsonCompanyDurationInfoToJSON,
} from './JsonCompanyDurationInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonCompanyDurationInfo
 */
export interface ApiResultOfListOfJsonCompanyDurationInfo {
    /**
     * 
     * @type {Array<JsonCompanyDurationInfo>}
     * @memberof ApiResultOfListOfJsonCompanyDurationInfo
     */
    data?: Array<JsonCompanyDurationInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyDurationInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonCompanyDurationInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyDurationInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyDurationInfo
     */
    result?: ApiResultOfListOfJsonCompanyDurationInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonCompanyDurationInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonCompanyDurationInfoFromJSON(json: any): ApiResultOfListOfJsonCompanyDurationInfo {
    return ApiResultOfListOfJsonCompanyDurationInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonCompanyDurationInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonCompanyDurationInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonCompanyDurationInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonCompanyDurationInfoToJSON(value?: ApiResultOfListOfJsonCompanyDurationInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonCompanyDurationInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

